import React from 'react';

import { Stack, TextField, Typography } from '@mui/material';

import { INVALID_HANDLING_FEE_MESSAGE, calculateAncillaryCustomerPrice, parseHandlingFee } from './pnrImport';

interface Props {
  /** What the seat or baggage is, like "VA-686 · seat 6A". */
  description: string;
  /** The airline's price for it, in its currency. */
  price: { amount: number; currency: string };
  /** The handling fee the agent typed, as typed. */
  fee: string | undefined;
  onFeeChange: (fee: string) => void;
  disabled?: boolean;
}

export default function PnrImportAncillaryFeeRow({ description, price, fee, onFeeChange, disabled }: Props) {
  const hasInvalidFee = parseHandlingFee(fee) === undefined;
  return (
    <Stack direction="row" spacing={2} alignItems="center" sx={{ pl: 3 }}>
      <Typography variant="body2" sx={{ minWidth: 150 }}>
        {description}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ minWidth: 150 }}>
        Airline {price.currency} {price.amount.toFixed(2)}
      </Typography>
      <TextField
        size="small"
        type="number"
        label={`Handling fee (${price.currency})`}
        value={fee ?? ''}
        onChange={(event) => onFeeChange(event.target.value)}
        slotProps={{ htmlInput: { min: 0, step: 0.01 } }}
        error={hasInvalidFee}
        helperText={hasInvalidFee && INVALID_HANDLING_FEE_MESSAGE}
        disabled={disabled}
        sx={{ maxWidth: 200 }}
      />
      <Typography variant="body2" sx={{ minWidth: 180 }}>
        Customer pays {price.currency} {calculateAncillaryCustomerPrice({ price }, fee).toFixed(2)}
      </Typography>
    </Stack>
  );
}
